export default `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Scantrust</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
      color: #1a1a2e;
      background: #ffffff;
      line-height: 1.6;
    }
    .hero {
      position: relative;
      width: 100%;
      aspect-ratio: 1 / 1;
      overflow: hidden;
      background: #f0f0f5;
    }
    .hero img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .badge {
      position: absolute;
      top: 16px;
      left: 16px;
      background: var(--stc-result-color);
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      padding: 6px 14px;
      border-radius: 20px;
    }
    .badge .stc-result { color: inherit; }
    .content {
      padding: 24px 20px;
    }
    .brand {
      font-size: 13px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #6b7280;
      margin-bottom: 4px;
    }
    .product-name {
      font-size: 26px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 16px;
    }
    .description {
      font-size: 15px;
      color: #4b5563;
      margin-bottom: 24px;
    }
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin-bottom: 24px;
    }
    .info-card {
      background: #f8f9fa;
      border-radius: 10px;
      padding: 14px;
    }
    .info-label {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #9ca3af;
      margin-bottom: 4px;
    }
    .info-value {
      font-size: 15px;
      font-weight: 600;
      color: #1a1a2e;
    }
    .cta {
      display: block;
      width: 100%;
      padding: 14px;
      background: #1a1a2e;
      color: #fff;
      text-align: center;
      text-decoration: none;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 24px;
    }
    footer {
      text-align: center;
      padding: 20px;
      font-size: 12px;
      color: #9ca3af;
      border-top: 1px solid #f0f0f0;
    }
    footer a {
      color: #6b7280;
      text-decoration: underline;
    }
  </style>
</head>
<body>
  <div class="hero">
    <img src="{product_image}" alt="{product_name}">
    <div class="badge">{scan_result}</div>
  </div>

  <div class="content">
    <div class="brand">{brand_name}</div>
    <h1 class="product-name">{product_name}</h1>
    <p class="description">{product_description}</p>

    <div class="info-grid">
      <div class="info-card">
        <div class="info-label">SKU</div>
        <div class="info-value">{product_sku}</div>
      </div>
      <div class="info-card">
        <div class="info-label">Serial</div>
        <div class="info-value">{serial_number}</div>
      </div>
      <div class="info-card">
        <div class="info-label">Scans</div>
        <div class="info-value">{scan_count}</div>
      </div>
      <div class="info-card">
        <div class="info-label">Location</div>
        <div class="info-value">{country}</div>
      </div>
    </div>

    <a href="{product_url}" class="cta">Learn More</a>
  </div>

  <footer class="stc-powered-by">
    Powered by Scantrust&trade; &middot; <a href="https://www.scantrust.com/privacy">Privacy Policy</a>
  </footer>
</body>
</html>`
